import { classnames } from '@aibees/shared/utils';
import { memo, useEffect } from 'react';
import { SearchCardTabs } from './components/search-card-tabs';
import { SearchListCardFilters } from './components/search-list-card-filters';
import { table } from './config';
import { tabPanels, tabs } from './constants';
import { useSearchListCardStore } from './store';
import * as Styled from './styles';
import * as SX from './sx';
import { type SearchListCardProps as Props } from './types';

export const SearchListCard = memo(
  ({ className, hasTabs, title, popoverState, onclose }: Props) => {
    const { setTitle, setState, state } = useSearchListCardStore();

    useEffect(() => {
      setTitle(title);

      if (!popoverState?.open) setState(false);
      onclose?.(state);
    }, [title, state, popoverState?.open]);

    return (
      <Styled.Wrapper
        className={classnames('SearchListCard', className)}
        sx={SX.root}
      >
        <SearchListCardFilters />

        {title && hasTabs && (
          <SearchCardTabs
            tabs={tabs}
            tabPanels={tabPanels}
            searchTable={table[title]}
          />
        )}
      </Styled.Wrapper>
    );
  }
);

SearchListCard.displayName = 'SearchListCard';
